import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {TableRequest} from "../../../../model/api/table-request";
import {TableButtonConfig} from "../../../../model/api/table-button-config";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {CcTableComponent} from "../../../../crystal-elements/table/cc-table.component";
import {AppConfigService} from "../../../../services/app-config.service";
import {BillingService} from "../../../../services/billing/billing.service";
import {Invoice} from "../../../../model/billing/invoice";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {Order} from "../../../../model/clearing/order";
import {Trade} from "../../../../model/clearing/trade";
import {InvoiceDetailLoadRequest} from "../../../../model/billing/invoice-detail-load-request";
import {TableEditColumnConfig} from "../../../../model/api/table-edit-column-config";
import TYPE = FormFieldConfig.TYPE;
import Side = Trade.Side;

@Component({
  selector: 'app-invoice-detail-table',
  templateUrl: './invoice-detail-table.component.html',
  styleUrls: ['./invoice-detail-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceDetailTableComponent extends CcBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  tableConfig: TableEditColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  records: Order[] = [];
  formRecord: Order;
  recordsChange = new EventEmitter<Order[]>();

  totalRecords: number = 0;
  inProgressCount: number = 0;

  tableLoading: boolean = true;
  forceReload: boolean = true;

  tableCurrentRequest: InvoiceDetailLoadRequest;
  tableCurrentRequestChange = new EventEmitter<TableRequest>();

  @Input()
  invoice: Invoice;

  @Input()
  transPartKey: string;
  @Input()
  visible: boolean = true;
  formConfig: FormFieldGroupConfig[] = [];
  @Input()
  detailDialogVisible: boolean = false;
  @Output()
  detailDialogVisibleChange = new EventEmitter<boolean>();

  @ViewChild('ccTable')
  public ccTable: CcTableComponent;

  constructor(cdref: ChangeDetectorRef,
              private commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected billingService: BillingService,
              protected appConfigService: AppConfigService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);

  }

  // ngAfterViewInit() {
  //   super.ngAfterViewInit();
  // }

  ngOnInit() {
    super.ngOnInit();
    setTimeout(() => {
      this.reLoadRecords();
    });
  }


  private getRowClass(record: Order) {
    if (record.manualInvoiceRemoved)
      return "order-removed";
    else if (record.settlementId != 0)
      return "order-paid";
    else if (Side.BUY === record.side)
      return "side-buy";
    else if (Side.SELL === record.side)
      return "side-sell";
  }

  private getRowValClass(record: Order) {
    if (Side.BUY === record.side)
      return "side-buy-val";
    else if (Side.SELL === record.side)
      return "side-sell-val";
  }

  private doPaid(record: Order) {
    if (!record.manualInvoiceRemoved) {
      record.settlementId = record.settlementId == -1 ? 0 : -1;
      this.ccTable.reloadTableValueMap();
    }
  }

  // private doRemove(record: Order) {
  //   record.manualInvoiceRemoved = !record.manualInvoiceRemoved;
  //   this.ccTable.reloadTableValueMap();
  // }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        width: 50,
        type: 'BUTTON',
        field: 'settlementId',
        notFilterable: true,
        notSortable: true,
        notResizable: true,
        class: value => 'centered ' + this.getRowClass(value),
        icon: value => value.settlementId == 0 ? 'fas fa-square order-unpaid-btt' : 'fas fa-square-check order-paid-btt',
        command: (record: Order) => {
          this.doPaid(record);
        },
        mapId: value => '',
        hidden: !this.isEditable(),
      },
      // {
      //   width: 50,
      //   type: 'BUTTON',
      //   field: 'manualInvoiceRemoved',
      //   notFilterable: true,
      //   notSortable: true,
      //   notResizable: true,
      //   class: value => 'centered ' + this.getRowClass(value),
      //   icon: value => value.manualInvoiceRemoved ? 'fas fa-square-check order-removed-btt' : 'fas fa-square order-not-removed-btt',
      //   command: (record: Order) => {
      //     this.doRemove(record);
      //   },
      //   mapId: value => '',
      //   hidden: !this.isEditable(),
      // },
      // {
      //   field: 'manualInvoiceRemoved',
      //   formFieldConfig: {
      //     field: 'manualInvoiceRemoved',
      //     column: 2,
      //     type: TYPE.CHECKBOX,
      //     useOffLabel: true,
      //   },
      //   class: record => this.getRowClass(record),
      //   editable: true,
      // },
      {
        field: 'giveUpBrokerCode',
        // formFieldConfig: {
        //   field: 'giveUpBrokerCode',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable(),
      },
      {
        field: 'trader',
        // formFieldConfig: {
        //   field: 'trader',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable(),
      },
      {
        field: 'customerName',
        // formFieldConfig: {
        //   field: 'customerName',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable()
      },
      {
        field: 'account_name',
        // formFieldConfig: {
        //   field: 'account_name',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable()
      },
      {
        field: 'account_reference1',
        // formFieldConfig: {
        //   field: 'account_reference1',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable()
      },
      {
        field: 'giveUpMessage',
        // formFieldConfig: {
        //   field: 'giveUpMessage',
        //   column: 2,
        //   type: TYPE.TEXT,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable()
      },
      {
        field: 'overrideBrokerageRateAmount',
        // formFieldConfig: {
        //   field: 'overrideBrokerageRateAmount',
        //   column: 2,
        //   type: TYPE.DECIMAL,
        // },
        class: record => this.getRowClass(record),
        // editable: this.isEditable(),
      },
      // {
      //   field: 'brokerageRateAmount',
      //   class: record => this.getRowClass(record),
      //   mapId: value => value.overrideBrokerageRateAmount > 0 ? value.overrideBrokerageRateAmount : value.brokerageRateAmount,
      // },
      // {
      //   field: 'brokerageOverrideReason',
      //   class: record => this.getRowClass(record),
      // },
      {
        field: 'brokerageFee',
        class: record => this.getRowClass(record),
      },
      {
        field: 'brokerageCurrency',
        class: record => this.getRowClass(record),
      },
      {
        field: 'exchangeCode',
        class: record => this.getRowClass(record),
      },
      {
        field: 'tradeType',
        class: record => this.getRowClass(record),
      },
      {
        field: 'reference',
        class: record => this.getRowClass(record),
      },
      {
        field: 'strategy',
        class: record => this.getRowClass(record),
      },
      {
        field: 'side',
        class: record => this.getRowClass(record) + ' ' + this.getRowValClass(record),
      },
      {
        field: 'volume',
        class: record => this.getRowClass(record),
      },
      {
        field: 'contractUnit',
        class: record => this.getRowClass(record),
      },
      {
        field: 'contractCode',
        class: record => this.getRowClass(record),
      },
      {
        field: 'maturity',
        class: record => this.getRowClass(record),
      },
      {
        field: 'callPut',
        class: record => this.getRowClass(record),
      },
      {
        field: 'strike',
        class: record => this.getRowClass(record),
      },
      {
        field: 'price',
        class: record => this.getRowClass(record) + ' ' + this.getRowValClass(record),
      },
      {
        field: 'avgPrice',
        class: record => this.getRowClass(record) + ' ' + this.getRowValClass(record),
      },
      {
        field: 'overrideAvgPrice',
        class: record => this.getRowClass(record) + ' ' + this.getRowValClass(record),
      },
      {
        field: 'state',
        class: record => this.getRowClass(record),
      },
      {
        field: 'clearingDate',
        format: 'dd/MM/yyyy',
        type: 'DATE',
        class: record => this.getRowClass(record),
      }];

  }

  private isEditable() {
    return !this.invoice.needAttention && (this.invoice.invoiceState === Invoice.InvoiceState.UNPAID ||
      this.invoice.invoiceState === Invoice.InvoiceState.PART_PAID ||
      this.invoice.invoiceState === Invoice.InvoiceState.ON_HOLD);
  }

  public refreshTable(invoice: Invoice) {
    this.invoice = invoice;
    this.initConfigs();
    setTimeout(() => {
      this.reLoadRecords();
    });
  }

  public reLoadRecords() {
    if (this.destroyed)
      return;

    setTimeout(() => {
      this.tableLoading = true;
      this.markForCheck();
    });
    this.ccTable.reloadTableValueMap();
    this.tableCurrentRequest = {
      invoiceId: this.invoice.id,
      first: 0,
      rows: 1000,
      sortOrder: -1,
      sortField: 'creationDate'
    }
    this.billingService.listDetail(this.tableCurrentRequest).subscribe(tableRecordResult => {
        // console.log("----> tableRecordResult " + JSON.stringify(tableRecordResult));
        // console.log("----> total " + tableRecordResult.total+"="+this.totalRecords);
        if (tableRecordResult.success) {
          // if (this.forceReload || this.totalRecords != tableRecordResult.total) {
          //   this.records.splice(0, this.records.length);
          tableRecordResult.records.forEach(order => {
            order.overrideBrokerageRateAmount = order.brokerageRateAmount;
            order['account_name'] = order.account ? order.account.name : '';
            order['account_reference1'] = order.account ? order.account.reference1 : '';
          });
          this.records = [];
          // this.forceReload = false;
          // }
          this.totalRecords = tableRecordResult.total;
          this.inProgressCount = 0;
          // this.applyRecordResult(tableRecordResult,
          //   this.tableCurrentRequest.first, this.tableCurrentRequest.first + this.tableCurrentRequest.rows);
          // this.records = [...this.records];
          this.records = [...tableRecordResult.records];
          // if(hasChanged){
          //   setTimeout(() => {
          //     this.records = [...this.records];
          //   });
          // }
          // @ts-ignore
          // this.records = tableRecordResult.records ? [...tableRecordResult.records] : [];
          this.recordsChange.emit(this.records);
          this.apiMessage(tableRecordResult);
          setTimeout(() => {
            this.tableLoading = false;
            this.markForCheck();
          });

        } else {
          this.errorMessage(tableRecordResult.message);
          setTimeout(() => {
            this.tableLoading = false;
            this.markForCheck();
          });
        }
        //refresh
        this.tableCurrentRequest.syncMetadata = tableRecordResult.syncMetadata;
        this.ccTable.reloadTableValueMap();
        this.markForCheck();
        // setTimeout(() => {
        //   this.reLoadRecords()
        // }, 30000);
      }
    );
  }

  // private applyRecordResult(tableRecordResult, from: number, to: number) {
  //   let hasChanged: boolean = false;
  //   tableRecordResult.records.forEach(newRecord => {
  //     const recordIndex = this.records.findIndex(record => record.id === newRecord.id);
  //     if (recordIndex >= 0) {
  //       for (let key in newRecord) {
  //         this.records[recordIndex][key] = newRecord[key];
  //       }
  //     } else {
  //       this.records.splice(0, 0, newRecord);
  //       hasChanged = true;
  //     }
  //   });
  //   return hasChanged;
  // }
  //
  // hasOneSelection(): boolean {
  //   return this.selectedRecords != undefined && this.selectedRecords.length == 1;
  // }

  // download(): void {
  //   if (this.selectedRecords) {
  //     this.formRecord = Object.assign({}, this.selectedRecords[0]);
  //   }
  //   if (this.formRecord) {
  //     if (Invoice.STATE.TREATED === this.formRecord.state) {
  //       this.reportTaskService.download(this.formRecord.id).subscribe(apiFileResponse => {
  //         if (apiFileResponse.success) {
  //           FileUtils.download(apiFileResponse);
  //         } else {
  //           this.successMessage(apiFileResponse.message);
  //         }
  //         this.tableLoading = false;
  //       });
  //     } else {
  //       this.infoMessage(this.getTranslation('page.' + this.transPartKey + '.message.not_treated'));
  //     }
  //   }
  // }

  onRowDblClick($event: any) {
    // if (this.invoice.invoiceState === Invoice.InvoiceState.VALIDATING) {
    //   // this.ccFormDialog.showDialog();
    //   if (this.selectedRecords) {
    //     this.formRecord = Object.assign({}, this.selectedRecords[0]);
    //   }
    //   if (this.formRecord) {
    //     this.formRecord.brokerageRateAmount = this.formRecord.overrideBrokerageRateAmount > 0 ?
    //       this.formRecord.overrideBrokerageRateAmount : this.formRecord.brokerageRateAmount
    //     this.dialogFormVisible = true;
    //   }
    //
    // }
  }

  // showDialogForm(record: Invoice): void {
  //   this.selectedProfile = Object.assign({}, JSON.parse(record.reportProfileJson));
  //   this.detailDialogVisible = true;
  //   // this.detailDialogVisibleChange.emit(true);
  // }

  closeDialogForm(): void {
    this.detailDialogVisible = false;
    // this.detailDialogVisibleChange.emit(false);
  }

  //
  // public needLoadRecords(request: InvoiceDetailLoadRequest = undefined) {
  //   this.tableLoading = true;
  //
  //   // if (this.tableCurrentRequest && ((this.tableCurrentRequest.filters.length === 0 && request.filters.length > 0)
  //   //   || (JSON.stringify(this.tableCurrentRequest.filters) != JSON.stringify(request.filters))
  //   //   || (this.tableCurrentRequest.sortField !== request.sortField)
  //   //   || (this.tableCurrentRequest.sortOrder != request.sortOrder)
  //   //   || (this.tableCurrentRequest.globalFilter !== request.globalFilter))) {
  //   //   setTimeout(() => {
  //   //     this.reLoadRecords();
  //   //   });
  //   // }
  //   if (request) {
  //     this.tableCurrentRequest = request;
  //     // this.tableCurrentRequest.states = this.states;
  //     // this.tableCurrentRequest.origins = this.origins;
  //     this.tableCurrentRequest.invoiceId = this.invoice.id;
  //   }
  //   this.tableCurrentRequest = {
  //     invoiceId: this.invoice.id,
  //     sortOrder: -1,
  //     sortField: 'creationDate'
  //   }
  //   if (this.tableCurrentRequest && !this.tableCurrentRequest.sortOrder) {
  //     this.tableCurrentRequest.sortOrder = -1;
  //     this.tableCurrentRequest.sortField = 'creationDate';
  //   }
  // }

  // refreshContextMenu() {
  //   // this.contextMenuConfig.forEach(menu => {
  //   //   if (menu.id === 'removeDetail') {
  //   //     menu.disabled = !this.hasOneSelection() || (this.hasOneSelection() && Invoice.InvoiceState.DRAFT != this.selectedRecords[0].invoiceState);
  //   //   }
  //   // });
  //   this.contextMenuConfig = [...this.contextMenuConfig];
  // }

  formRecordChanged(formRecord: any) {
    //store record
    // this.cookieService.set(this.origin + '_' + CookieNames.ARCHIVE_FORM_RECORD, JSON.stringify(this.formRecord));
    // console.log("---------------> " + JSON.stringify(this.formRecord))
  }


}
